<div class="smooth-scrolling">

<!-- thank you page design start  -->


<section  class="thank-you-section">
  <div class="row">
      <div class="col-12">
          <div class="thank-you-detail">
            <div *ngIf="!paymentSuccess" class="thank-you-img">
                <h5 class="d-flex d-lg-none">OH UH!</h5>
                <span class="thank-img"><img src="../../../assets/images/thank-you.svg" alt="img"></span>
                <h5 class="d-lg-flex d-none">OH UH!</h5>
                <div class="thank-you-order-detaul">
                </div>

            </div>
              <div class="thank-you-order">
                  <label>Order Number</label>
                  <span>FOY-{{orderDetail?.order_number}}</span>
              </div>
              <div *ngIf="paymentSuccess" class="thank-you-img">
                <h5 class="d-flex d-lg-none">Thank you!</h5>
                  <span class="thank-img"><img src="../../../assets/images/thank-you.svg" alt="img"></span>
                  <h5 class="d-lg-flex d-none">Thank you!</h5>
                  <div class="thank-you-order-detaul">
                      <span>Your Order Has Been Placed Successfully!</span>
                      <span class="order-detail-text"><small class="time-icon"><img src="../../../assets/images/time-icocn.svg" alt="icon"></small>Your order will reach you in 5-6 working days</span>
                  </div>

              </div>
          
          </div>
          <div class="order-summary">
              <div class="order-summary-text">
                  <span class="title-order-summary">Order Summary</span>
                  <div class="order-summary-detai-text">
                      <label>Payment time & Date</label>
                      <span>{{setDateFormat(orderDetail?.order_date)}}</span>
                  </div>
                  <div class="order-summary-detai-text">
                      <label>Total No. of Items</label>
                      <span>{{qty}}</span>
                  </div>
                  <div class="order-summary-detai-text" *ngIf="orderDetail?.total_discount_amount > 0">
                      <label>Discount</label>
                      <span><small class="offersdiscount">(-)</small>₹{{orderDetail?.total_discount_amount}}</span>
                  </div>
                  <div class="order-summary-detai-text" *ngIf="orderDetail?.cod">
                      <label>COD Charges</label>
                      <span>₹0</span>
                  </div>
                  <div class="order-summary-detai-text">
                      <label>Total Amount </label>
                      <span>₹{{totalAmountWithTaxDiscount}}</span>
                  </div>
              </div>
          </div>
          <div class="working-day" *ngIf="paymentSuccess">
              <span class="working-text">We will send you the tracking details shortly!</span>
              <div class="track-orde">
                  <ul>
                      <li><a class="track-orde-btn view-order" (click)="viewOrderDetails()">View Order Details</a></li>
                  </ul>
              </div>
          </div>
          <div class="working-day" *ngIf="!paymentSuccess"> 
              <div class="track-orde">
                  <ul>
                      <li><a class="track-orde-btn view-order" (click)="tryAgain()">Try Again</a></li>
                  </ul>
              </div>
          </div>

          <div class="foy-detail-text">
            <h5>For You</h5>
            <div class="row justify-content-center px-2">
                <div class="col-lg-6">
                    <div class="row justify-content-center">
                      
                          <div class="col-6 padding-remove" >
                            <div class="p-relative m-box">
                                <div class="foy-for-you-img">
                                    <span class="d-lg-flex d-none">
                                        <img src="../../../assets/images/foy-for-you.png" alt="img">
                                    </span>
                                    <span class="d-lg-none d-flex">
                                        <img src="../../../assets/images/foy-for-you-mobile.png" alt="img">
                                    </span>
                                    
                                </div>
                                <a class="read-blog-btn" href="blog">Read Blogs</a>
                            </div>
                          </div>
                          <div class="col-6 padding-remove" >
                            <div class="p-relative m-box">
                                <div class="foy-for-you-img">
                                    <span class="d-lg-flex d-none">
                                        <img src="../../../assets/images/foy-for-you-1.png" alt="img">
                                    </span>
                                    <span class="d-lg-none d-flex">
                                        <img src="../../../assets/images/foy-for-you-mobile-1.png" alt="img">
                                    </span>
                                </div>
                                <a class="read-blog-btn" href="shop-all">Shop More</a>
                            </div>
                          </div>
                      
                    </div>
                </div>
            </div>
        </div>
      </div>
     
  </div>
</section>
<section class="foy-wishlist">
    <div class="arrow-btn">
        <div class="foy-favouraties" *ngIf="paymentSuccess && tagsProducts && tagsProducts.length > 0">
            <h5>FOY Favouraties</h5>
            <div class="foy-favouraties-detail scrollbar-width-none " id="foyfav" #foyfav >
                <a class="left-arrow-btn" *ngIf="showfoyfavLeftArrow"><img (click)="goLeft('foyfav')"
                    src="/assets/images/left-arrow.png" alt=""></a>
                <div class="col-lg-3 col-md-4 col-6 px-lg-2 px-1"  *ngFor="let product of tagsProducts; let i  = index">
                    <app-product-box [color]="product.category ? product.category.color : ''" [product]="product"
                    [mAddUpdateCartModule]="mAddUpdateCartModule"
                    [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse"
                    [mWishlistData]="mWishlistData"></app-product-box>
                </div>
                <a class="right-arrow-btn" *ngIf="showfoyfavRightArrow"><img (click)="goRight('foyfav')"
                    src="/assets/images/right-arrow.png" alt=""></a>
            </div>
        </div>
    </div>
  </section>
</div>
<app-footer-bg></app-footer-bg>


<!-- thank you page design End  -->
